import React, { createContext, useState, useContext, useRef, useCallback } from 'react';

// 创建 AppContext 上下文
const AppContext = createContext();

// 创建提供 App 相关状态的组件
export const AppProvider = ({ children }) => {
    // 服务器 URL 状态
    //const [ServiceURLPrefix, setSelectedServer] = useState("https://localhost:8000");
    // const [ServiceURLPrefix, setSelectedServer] = useState("https://hqtapi.c2.world:8000");
    // const [ServerName, setServerName] = useState("hqtapi.c2.world");
    const [ServiceURLPrefix, setSelectedServer] = useState("https://hqtapi.aizhonghuajia.com:8000");
    const [ServerName, setServerName] = useState("hqtapi.aizhonghuajia.com");
    const [username, setUsername] = useState('');

    // 统一管理 modal 状态。FIXME：这个方法导致只能控制对话框的开关，但里面用到的数据没法被更新，尝试了在RevisionCard.js组件里增加revison的hook等等办法都解决不了，还没找到办法。所以暂时先这样。
    // const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
    // const [isRawMsgModalOpen, setIsRawMsgModalOpen] = useState(false);
    // const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);  // 删除确认框状态

    const [localTimezone, setLocalTimezone] = useState('Asia/Singapore');

    const [localDiff, setLocalDiff] = useState(0);
    const [localPosition, setLocalPosition] = useState(10);

    const [message, setMessage] = useState('');

    const logWSRetries = useRef(0); // 追踪重连次数

  // 新增：全局交互禁用状态，用于在等待后端反馈时禁止页面交互
  const [isBlocking, setIsBlocking] = useState(false);
  const blockPage = useCallback(() => setIsBlocking(true), []);
  const unblockPage = useCallback(() => setIsBlocking(false), []);

    return (
        <AppContext.Provider value={{
            ServiceURLPrefix, setSelectedServer,
            ServerName, setServerName,
            username, setUsername,
            // isStatusModalOpen, setIsStatusModalOpen,
            // isRawMsgModalOpen, setIsRawMsgModalOpen,
            // isDeleteModalOpen, setIsDeleteModalOpen, // 暴露删除确认框的状态管理

            localTimezone, setLocalTimezone,

            localDiff, setLocalDiff,
            localPosition, setLocalPosition,

            message, setMessage,

            logWSRetries,
            isBlocking, blockPage, unblockPage,  // 新增全局阻塞功能
        }}>
            {children}
        </AppContext.Provider>
    );
};

// 自定义 Hook 供组件使用
export const useAppContext = () => useContext(AppContext);
